module.exports = __webpack_public_path__ + "img/slider-1.c4cf6ba9.jpeg";